import { useTranslation } from "react-i18next";
import Modal from "../../Modal";
import Body from "../../../atoms/typography/Body";
import { HorizontalSpacer } from "../../../atoms/Spacers";
import DuplicatedInvoiceNumberListModalContent from "./DuplicatedInvoiceNumberListModalContent";

interface Props {
  clientIdentifier: string;
  invoiceId: string;
  onClickSendToAssessment: () => void;
  onCancel: () => void;
}

const SendValidationInvoiceToAssessmentWithDupesModal: React.FC<Props> = ({
  clientIdentifier,
  invoiceId,
  onClickSendToAssessment,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <Modal
        onClose={onCancel}
        width={1200}
        closeIcon
        title={t("invoices.sendToAssessment")}
        actionButtons={{
          defaultButton: {
            buttonTitle: t("common.cancel"),
            onClick: onCancel,
          },
          actionButton: {
            buttonTitle: t("invoices.sendToAssessment"),
            onClick: () => {
              onCancel();
              onClickSendToAssessment();
            },
          },
        }}
      >
        <Body>
          {t(
            "invoiceValidation.invoiceHasDuplicatedInvoiceNumbersThatShouldBeHandledBeforeAssessment",
          )}
        </Body>
        <HorizontalSpacer spacing={2} />
        <DuplicatedInvoiceNumberListModalContent
          clientIdentifier={clientIdentifier}
          invoiceId={invoiceId}
        />
      </Modal>
    </div>
  );
};

export default SendValidationInvoiceToAssessmentWithDupesModal;
